import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/close.png'


const _hoisted_1 = { class: "english-form__wrapper" }
const _hoisted_2 = { class: "english-form" }
const _hoisted_3 = { class: "nglish-form__content" }
const _hoisted_4 = { class: "english-form__header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Напишите перевод слова:", -1)
const _hoisted_6 = { class: "english-form-title" }
const _hoisted_7 = { class: "english-form__middle" }
const _hoisted_8 = { class: "english-form__footer" }
const _hoisted_9 = {
  key: 4,
  class: "english-form__answer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_words_image = _resolveComponent("words-image")!
  const _component_correct_answer = _resolveComponent("correct-answer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(_ctx.wordData.english), 1),
            _createVNode(_component_words_image, {
              "img-url": _ctx.wordData.img
            }, null, 8, ["img-url"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            ref: "inputWord",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.word.value) = $event)),
            type: "text",
            onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.checkInput && _ctx.checkInput(...args)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.word.value]
          ]),
          _createElementVNode("button", {
            class: "profile__run modal-button__run",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.checkInput && _ctx.checkInput(...args)))
          }, " Проверить ")
        ]),
        _createVNode(_component_correct_answer, {
          isDone: _ctx.isDone.value,
          isError: _ctx.isError.value
        }, null, 8, ["isDone", "isError"]),
        _createElementVNode("div", _hoisted_8, [
          (parseInt(_ctx.taskNum) > 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "profile__run",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('previousTask')))
              }, " Вернуться "))
            : _createCommentVNode("", true),
          (!_ctx.isAnswer.value && !_ctx.isDone.value && _ctx.isError.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "profile__run modal-button__run",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setAnswer(true)))
              }, " Посмотреть ответ "))
            : _createCommentVNode("", true),
          (parseInt(_ctx.taskNum) != _ctx.len)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "profile__run modal-button__run",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.nextTask && _ctx.nextTask(...args)))
              }, " Далее "))
            : (_openBlock(), _createElementBlock("button", {
                key: 3,
                class: "profile__run modal-button__run",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.setFinish && _ctx.setFinish(...args)))
              }, " Завершить ")),
          (!_ctx.isDone.value && _ctx.isAnswer.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                _createElementVNode("p", null, _toDisplayString(_ctx.wordData.russian), 1),
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "close",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setAnswer(false)))
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}